import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { decryptData } from './helper';

const costColumns = ['Total Billed Amount', 'Total Paid Amount'];

export const getColumns = (columns_list: string[]) => {
  const cellStyles = {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
    color: patientAccessTheme.palette.text.mediumemphasis,
  };

  const columns: Columns[] = columns_list.map((item: string, index: number) => {
    return {
      name: item,
      align: costColumns?.includes(item) ? 'right' : 'left',
      cellStyles,
      cellPadding: index === 0 ? '' : '8px 18px 8px 16px',
      width: '',
    };
  });
  return columns;
};

export const getData = (
  data: any[],
  columns_list: string[],
  memberIdentification: boolean,
) => {
  const formattedArray = data.map((claim) => {
    return columns_list.map((feature) => {
      const value = claim[feature];

      if (Array.isArray(value)) {
        return value.length ? value.join('|') : '-';
      }
      if (feature === 'Gender') {
        return value === 'F' ? 'Female' : 'Male';
      }
      if (feature === 'First Name' && memberIdentification) {
        return decryptData(value);
      }
      if (feature === 'Last Name' && memberIdentification) {
        return decryptData(value);
      }

      return value !== undefined && value !== null ? value : '-';
    });
  });

  return formattedArray;
};
